import * as R from "ramda";
import FlexView from "react-flexview";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import MasterLogistikTable from "../../masterLogistikMotor/common/masterLogistikTable";
import React, {Component} from "react";
import {formGroupHadiah, tableConfig} from "../config";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import MasterHadiahModifying from "./modal/MasterHadiahModifying";
import MasterHadiahFilter from "./modal/MasterHadiahFilter";
import Api from "../../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class MasterKSU extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.hadiah;
        this.initialData = {
            id: null,
            kodeHadiah: null,
            nameHadiah: null,
            categoryHadiah: null,
            qrHadiah: null,
            satuanHadiah: null
        };
        this.initialSearch = {
            nameHadiah: null,
        }
        this.state = {
            loading: false,
            filterModalVisible: false,
            modifyingVisible: false,
            selectedData: null,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
            dataTable: [],
            dataKategoriDDL: [],
            dataSatuanDDL: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataHadiah();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        if (!this.state.modifyingVisible) {
            await this.fetchDataCategory();
            await this.fetchDataSatuan();
        }

        if (!R.isNil(index)) {
            let res = await this.callApi(
                Api.create("NAGAMAS_MASTER_DATA").getHadiahById,
                this.state.dataTable[index].kodeHadiah,
            );
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        categoryHadiah: mapToObjectDDL(
                            res.data.data.categoryDTO.value,
                            res.data.data.categoryDTO.key
                        ),
                        satuanHadiah: mapToObjectDDL(
                            res.data.data.satuanDTO.value,
                            res.data.data.satuanDTO.key
                        ),
                        qrHadiah: mapToObjectDDL(
                            res.data.data.qrHadiah ? "YES" : "NO",
                            !!res.data.data.qrHadiah,
                        ),
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleModalFilterVisibility = async () => {
        this.handleTriggerLoading();
        if (!this.state.filterModalVisible) {
            await this.fetchDataCategory();
            await this.fetchDataSatuan();
        }

        this.setState((prevState) => ({
            ...prevState,
            selectedData: this.initialData,
            filterModalVisible: !prevState.filterModalVisible,
        }));
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            categoryHadiah: getValueFromDDL(formGroup, "categoryHadiah"),
            satuanHadiah: getValueFromDDL(formGroup, "satuanHadiah"),
            qrHadiah: getValueFromDDL(formGroup, "qrHadiah"),
        };
        let api;
        if (!R.isNil(this.state.selectedData)) {
            api = Api.create("NAGAMAS_MASTER_DATA").updateHadiah;
        } else {
            api = Api.create("NAGAMAS_MASTER_DATA").saveHadiah;
        }
        let res = await this.callApi(api, requestBody);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            this.handleResetAllFilters();
            const {submittedFilterData,pagination} = this.state;
            await this.fetchDataHadiah({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.handleClearSearch();
        let req = {
            paramFilters: removeNullFields(this.parseFilterData(this.state.filterData)),
            limit: this.state.pagination.limit,
            page: 1
        };
        this.handleChangeSubmittedFilterData(req.paramFilters);
        await this.handleModalFilterVisibility();
        await this.fetchDataHadiah(req);
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let requestBody = {
            kodeHadiah: data.kodeHadiah,
            status: data.status,
        }

        let res = await this.callApi(Api.create("NAGAMAS_MASTER_DATA").updateStatusHadiah, requestBody);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            const {submittedFilterData,pagination} = this.state;
            await this.fetchDataHadiah({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleSearch = async () => {
        this.handleTriggerLoading();
        this.handleClearForm();
        let req = {
            paramFilters: removeNullFields(this.state.search),
            limit: this.state.pagination.limit,
            page: 1
        };
        this.handleChangeSubmittedFilterData(req.paramFilters);
        await this.fetchDataHadiah(req);
        this.handleTriggerLoading();
    }

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClickDelete = async (index) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        let res = await this.callApi(Api.create("NAGAMAS_MASTER_DATA").deleteHadiah, data.kodeHadiah);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            const {submittedFilterData,pagination} = this.state;
            await this.fetchDataHadiah({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleClearForm = () => {
        this.setState((prevValue) => ({...prevValue, filterData: this.initialData}));
    };

    handleClearSearch = () => {
        this.setState((prevValue) => ({...prevValue, search: this.initialSearch}));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        let {submittedFilterData} = this.state;
        await this.fetchDataHadiah({
            paramFilters: submittedFilterData,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        let {submittedFilterData} = this.state;
        await this.fetchDataHadiah({
            paramFilters: submittedFilterData,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataHadiah = async (body) => {
        this.setState((prevValue) => ({...prevValue, pagination: {...prevValue.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            };
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllHadiahPagingByParam,
            req,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    }

    fetchDataCategory = async () => {
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
            {paramFilters: {bizparCategory: "GIFT_TYPE"}},
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataKategoriDDL: res.data.data.map(item => mapToObjectDDL(item.value, item.key)),
            }));

        }
    }

    fetchDataSatuan = async () => {
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
            {paramFilters: {bizparCategory: "UNIT_TYPE"}},
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSatuanDDL: res.data.data.map(item => mapToObjectDDL(item.value, item.key)),
            }));

        }
    }

    parseFilterData(data) {
        return {
            ...data,
            categoryHadiah: getValueFromDDL(data, "categoryHadiah"),
            satuanHadiah: getValueFromDDL(data, "satuanHadiah"),
            qrHadiah: getValueFromDDL(data, "qrHadiah"),
        };
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Logistik Non Motor - Hadiah",
            setError: this.props.setError,
            args: args,
        })
    };

    handleChangeSubmittedFilterData = (data) => {
        this.setState((prevState) => ({
            ...prevState,
            submittedFilterData: data,
        }));
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
        }));
    };

    render() {
        return (
            <>
                <FlexView style={{justifyContent: "space-between"}} className="margin-bottom-5px margin-top-5px">
                    <FlexView vAlignContent="center" className="margin-bottom-5px">
                        <SimpleInput
                            type="text"
                            name="nameHadiah"
                            placeholder="Nama Hadiah"
                            containerclassname="margin-bottom-none"
                            onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                            value={this.state.search.nameHadiah}
                        />
                        <SimpleButton onClick={this.handleSearch} className="margin-top-5px">Cari</SimpleButton>
                    </FlexView>
                    <SimpleButton
                        onClick={this.handleModalFilterVisibility}
                        styles={{width: "unset", marginTop: "5px"}}
                        icon={<i className={"fa fa-qrcode"}></i>}
                    />
                </FlexView>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onDelete={this.handleClickDelete}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        <FlexView vAlignContent="center">
                            {
                                this.props.menuAccess && this.props.menuAccess.createAccess && (
                                    <SimpleButton
                                        onClick={() => this.handleModifyingModalVisibility()}
                                        icon={<i className="fa fa-plus margin-right-10px"></i>}
                                        text={"Tambah"}
                                    />
                                )
                            }
                        </FlexView>
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterHadiahModifying
                        formGroup={formGroupHadiah}
                        initialValues={this.state.selectedData}
                        selectedData={this.state.selectedData}
                        dataKategoriDDL={this.state.dataKategoriDDL}
                        dataSatuanDDL={this.state.dataSatuanDDL}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.filterModalVisible && (
                    <MasterHadiahFilter
                        selectedData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        dataKategoriDDL={this.state.dataKategoriDDL}
                        dataSatuanDDL={this.state.dataSatuanDDL}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleValueChange}
                        onClearForm={this.handleClearForm}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterKSU;
